import { render } from "./PageTitleComponent.vue?vue&type=template&id=2dc2579e"
import script from "./PageTitleComponent.vue?vue&type=script&lang=js"
export * from "./PageTitleComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/mohsen-ampd-agency/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__